import { useEffect, useState } from 'react';
import { useClockStore } from '@/state/clockStore';
import { ui } from './theme';

const PHASE_ICON: Record<string, string> = {
  dawn: '🌅',
  day: '☀️',
  dusk: '🌇',
  night: '🌙',
};

const WEATHER_ICON: Record<string, string> = {
  clear: '',
  rain: '🌧️',
  storm: '⛈️',
  fog: '🌫️',
  snow: '❄️',
};

const WEATHER_LABEL: Record<string, string> = {
  clear: 'Quang đãng',
  rain: 'Mưa',
  storm: 'Bão',
  fog: 'Sương mù',
  snow: 'Tuyết',
};

function fmt(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

export function ClockHud() {
  const snapshot = useClockStore((s) => s.snapshot);
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setTick((x) => x + 1), 1000);
    return () => window.clearInterval(id);
  }, []);
  if (!snapshot) return null;
  const now = useClockStore.getState().getNow();
  if (!now) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 56,
        right: 12,
        ...ui.panel,
        padding: '6px 10px',
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        fontSize: 13,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
      title={`Phase: ${now.phase} — Weather: ${WEATHER_LABEL[now.weather] ?? now.weather}`}
    >
      <span style={{ fontSize: 16 }}>{PHASE_ICON[now.phase] ?? ''}</span>
      <span style={{ fontFamily: 'monospace', minWidth: 48, textAlign: 'center' }}>
        {fmt(now.hour)}:{fmt(now.minute)}
      </span>
      {now.weather !== 'clear' && (
        <span style={{ fontSize: 16 }}>{WEATHER_ICON[now.weather]}</span>
      )}
    </div>
  );
}
